export default function toasterLineHeight (toasterContent: string): string {
  return `${toasterContent.length > 40 ? 39 / 2 : 39}px`;
}
